import { CanDeactivate, CanActivate } from '@angular/router';
import { GameComponent } from './game.component';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";

//export default class DeactivateGuard implements CanDeactivate<GameComponent> {
export class DeactivateGuard implements CanDeactivate<GameComponent> {

  canDeactivate(component: GameComponent) {
    /*//let can = component.canDeactivate();
    let can = Observable.of(confirm("Are you sure?"));
    console.log('DeactivateGuard#canDeactivate called, can: ', can);
    if (!can) {
      console.log('Deactivation blocked');
      return false;
    }

    return true;*/

    // return new Promise(r => {
    //     let can = confirm("Are you sure?");
    //     console.log('DeactivateGuard#canDeactivate called, can: ', can);
    //     if (!can) {
    //         alert('Deactivation blocked');
            
    //         //this.router.navigate([state.url]);
    //         r(false);
    //     }

    //     r(true);
    // });

    //return Observable.of(window.confirm('Are you sure you want to quit this screen?'));
    return Observable.of(component.canDeactivate());
    
    //let can =  Observable.of(component.canDeactivate());
    //console.log('DeactivateGuard#canDeactivate finished, can: ', can);
    //return can;

    //return Observable.of(component.canDeactivate());
    //return Observable.of(component.canDeactivate ? component.canDeactivate() : true);
  }

}

export class ActivateGuard implements CanActivate {
  constructor() /*private _router: Router*/ {     
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) { //: Observable<boolean>|Promise<boolean>|boolean {
    console.log("canActivate");
    //var gameId = +route.params['id']; // (+) converts string 'id' to a number
    //
    // Need to validate real game #
    
    // if (gameId < 1 || gameId > 4 ) {
    //   this._router.navigateByUrl('/');
    //   return false;          
    // }
    // if (localStorage.getItem('currentUser')) {
    //   // logged in so return true
    //   return true;
    // }

    // // not logged in so redirect to login page with the return url and return false
    // //this.router.navigate(['/game/login'], { queryParams: { returnUrl: state.url }});
    // this._router.navigateByUrl('/game/login');
    // return false;


    return true;
  }
}


// WEBPACK FOOTER //
// ./src/app/game/deactivate-guard.ts